import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useTranslation } from 'react-i18next';

export type Action = 'append' | 'replace';
type ActionsButtonTypes = { action: string; setAction: (arg1: Action) => void };

export default function ActionButtonsGroup({
    action,
    setAction,
}: ActionsButtonTypes) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
        setAction(event.target.value as Action);
    const { t } = useTranslation();
    return (
        <FormControl variant="standard" component="fieldset">
            <RadioGroup name="action" value={action} onChange={handleChange}>
                <FormControlLabel
                    value="append"
                    control={<Radio />}
                    label={t('importCSV.addNewData')}
                />
                <FormControlLabel
                    value="replace"
                    control={<Radio />}
                    label={t('importCSV.deleteAndReplace')}
                />
            </RadioGroup>
        </FormControl>
    );
}
